import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type { Media, UploadPOSTUrls } from '@studio/types';

export const root = {
  [HTTP_METHODS.POST]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/archive/upload`,
    request: {} as Media.Post.UploadUrls,
    response: {} as UploadPOSTUrls,
    method: HTTP_METHODS.POST,
  },
};
